import { clsx } from 'clsx'
import { Button } from 'design-system/ui/atoms/button'
import { isString } from 'lodash'
import { KeyIcon } from 'lucide-react'

import type { GetInternalActionExecutionLogByIdResponse } from '~/generated/client'
import { formatTimeInMS } from '~/utils/time'
import {
  blockHeadingStyle,
  blockSubHeadingStyle,
  Dot,
  InfoButton,
  LineHeading,
} from '../components/common'

export const ConnectionBlock = ({
  data,
  connectionId,
}: {
  data: GetInternalActionExecutionLogByIdResponse['steps'][number]
  connectionId: string
}) => {
  const { message, totalDuration, startTime } = data
  const encryption = data?.metadata?.encryption

  const handleConnectionClick = () => {
    window.open(`/connection/${connectionId}`, '_blank')
  }

  return (
    <div className="ds-flex ds-items-center ds-gap-2 relative w-full">
      <Dot />
      <div className="w-full pl-[8px]">
        <div className="flex w-full flex-col gap-2">
          <div className="flex items-center gap-1">
            <div
              className={clsx(
                blockHeadingStyle,
                'flex w-full items-center justify-between',
              )}
            >
              <LineHeading />
              <div className="flex items-center gap-2">
                Fetched connection details
                <InfoButton
                  state="info"
                  icon={
                    <KeyIcon
                      className="ds-w-12 ds-h-12"
                      height={12}
                      width={12}
                    />
                  }
                />
                {isString(encryption) && (
                  <div className="ds-text-10 ds-text-black-600 ds-font-400 ds-bg-gray-100 ds-px-2 ds-py-1 ds-rounded-full">
                    {encryption || ''}
                  </div>
                )}
              </div>
              <div
                className={clsx(
                  'ds-text-11 ds-font-400 ds-font-mono ds-text-black-900',
                )}
              >
                {formatTimeInMS(new Date(startTime))}
              </div>
            </div>
          </div>
          <div
            className={clsx(
              blockSubHeadingStyle,
              'mt-[2px] flex justify-between pr-4',
            )}
          >
            <span>{message}</span>
            <span>{totalDuration}ms</span>
          </div>
          {connectionId && (
            <div>
              <Button
                variant="secondary_outline"
                onClick={handleConnectionClick}
                size="28"
                className="ds-mt-4"
              >
                View connection
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
